import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import WeatherWidget from "@/components/WeatherWidget";
import { DateLine } from "@/components/DateTime";

const NAV = [
  { to: "/", label: "Home", id: "nav-home-link" },
  { to: "/galleries", label: "Galleries", id: "nav-galleries-link" },
  { to: "/articles", label: "Articles", id: "nav-articles-link" },
  { to: "/locations", label: "Locations", id: "nav-locations-link" },
  { to: "/events", label: "Events", id: "nav-events-link" },
  { to: "/market", label: "Market", id: "nav-market-link" },
  { to: "/about", label: "About", id: "nav-about-link" },
];

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors duration-200 ${isActive ? "text-[#1f402b]" : "text-[#5a665e] hover:text-[#1f402b]"}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#fcfbfa]/85 backdrop-blur-xl border-b border-[#e2dcd4]" data-testid="site-header">
      <div className="border-b border-[#e2dcd4]/70">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-7 flex items-center justify-between">
          <DateLine />
          <span className="hidden sm:inline font-mono-k text-[11px] text-[#5a665e]">Aotearoa New Zealand</span>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo-link">
          <img src="/logo-badge.png" alt="Kiwibares badge — Happiness is no tan lines" className="w-9 h-9 sm:w-10 sm:h-10" />
          <span className="flex items-baseline gap-1.5">
            <span className="font-display text-xl sm:text-2xl text-[#1f402b] tracking-tight">kiwibares</span>
            <span className="font-mono-k text-[11px] text-[#c5903b]">.nz</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} className={linkCls} data-testid={n.id}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <WeatherWidget compact />
          <button className="lg:hidden p-2 text-[#1f402b]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-[#e2dcd4] bg-[#fcfbfa] px-5 py-4 flex flex-col gap-4" data-testid="mobile-nav">
          {[...NAV, { to: "/contact", label: "Contact", id: "nav-contact-link" }].map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} className={linkCls} onClick={() => setOpen(false)} data-testid={`${n.id}-mobile`}>
              <span className="font-display text-2xl">{n.label}</span>
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
